var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h2", { staticClass: "subtitle is-6" }, [_vm._v(" Routes ")]),
    _c(
      "ul",
      [
        _vm._l(_vm.routes, function (v, idx) {
          return _c("li", { key: idx }, [
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field has-addons" }, [
                  _c("p", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: v.route,
                          expression: "v.route",
                        },
                      ],
                      staticClass: "input is-small",
                      attrs: { type: "text", placeholder: "Route" },
                      domProps: { value: v.route },
                      on: {
                        change: function ($event) {
                          return _vm.update(v)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(v, "route", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: v.link,
                          expression: "v.link",
                        },
                      ],
                      staticClass: "input is-small",
                      attrs: { type: "text", placeholder: "Link" },
                      domProps: { value: v.link },
                      on: {
                        change: function ($event) {
                          return _vm.update(v)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(v, "link", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _c("p", { staticClass: "control" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-danger is-small",
                        on: {
                          click: function ($event) {
                            return _vm.deleteChild(v, idx)
                          },
                        },
                      },
                      [_vm._m(0, true)]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ])
        }),
        _c(
          "li",
          {
            staticClass: "has-text-right",
            staticStyle: { "margin-top": "1em" },
          },
          [
            _c(
              "button",
              {
                staticClass: "button is-success is-small",
                attrs: { disabled: !_vm.canAddChild() },
                on: {
                  click: function ($event) {
                    return _vm.addChild()
                  },
                },
              },
              [_vm._m(1), _c("span", [_vm._v(" Route ")])]
            ),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-trash-can-outline mdi-20px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", {
        staticClass: "mdi mdi-plus",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }